import { useEffect, useState } from 'react';
import { type PwaEnvironment, readCurrentPwaEnvironment } from './detection.js';

export function usePwaEnvironment(): PwaEnvironment | null {
  const [environment, setEnvironment] = useState<PwaEnvironment | null>(() =>
    typeof window === 'undefined' ? null : readCurrentPwaEnvironment(),
  );

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const standaloneQuery = window.matchMedia?.('(display-mode: standalone)');
    const updateEnvironment = () => setEnvironment(readCurrentPwaEnvironment());

    standaloneQuery?.addEventListener('change', updateEnvironment);
    updateEnvironment();

    return () => {
      standaloneQuery?.removeEventListener('change', updateEnvironment);
    };
  }, []);

  return environment;
}
